import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header_title fs20 fw600 centered mt20 mb20" }, "登録済み場所一覧", -1)
const _hoisted_2 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_3 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "選択", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_SelectLocationsList = _resolveComponent("SelectLocationsList")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "SelectLocationsModal",
    "content-class": "rad10 pad15 with_white_bg shadowContent modalNarrow noscroll"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "w100 ofs",
        style: _normalizeStyle(`height: ${_ctx.contentHeight}px;overscroll-behavior: contain;`)
      }, [
        _hoisted_1,
        _createVNode(_component_SelectLocationsList, {
          loctags: _ctx.loctags,
          appo: _ctx.appo,
          systemUpdatedAt: _ctx.systemUpdatedAt,
          selectLocation: _ctx.selectLocation,
          clickFree: _ctx.clickFree
        }, null, 8, ["loctags", "appo", "systemUpdatedAt", "selectLocation", "clickFree"])
      ], 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, _hoisted_8)
        ])
      ])
    ]),
    _: 1
  }))
}